import React from 'react';
import { LinkedinSquare } from '@saleshandy/icons';

const Linkedin = () => (
  <LinkedinSquare className="blue-txt-11" />
);

export default Linkedin;
